import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState, useMemo, useEffect, useReducer, useContext } from 'react';
import styled from 'styled-components';
import { Slider } from 'antd';
import { ActionSheet } from 'zarm';
import { MinusOutlined, PlusOutlined, CaretDownOutlined } from '@ant-design/icons';
import { subscribe, dispatch as dvaDispatch } from '@/store';
import { ModuleContext } from '../BaseModule';
import './index.less';

const reducer = (store, {
  type,
  payload
}) => {
  switch (type) {
    case 'setState':
      return _objectSpread(_objectSpread({}, store), payload);

    default:
      return store;
  }
};

const initialState = {
  sheetVisible: false,
  // current: {},
  index: 0
};

const BenefitDemonstrationSlider = props => {
  var _datas$;

  const {
    attrs,
    productBenefit
  } = props;
  const {
    benefitTable
  } = useContext(ModuleContext);
  const {
    datas,
    titles
  } = benefitTable || {};
  const [store, dispatch] = useReducer(reducer, initialState);

  const setState = payload => {
    dispatch({
      type: 'setState',
      payload
    });
  };

  const selectedHandle = (data, i) => {
    setState({
      sheetVisible: false,
      i
    });
  };

  const dataList = useMemo(() => {
    return datas === null || datas === void 0 ? void 0 : datas.map((item, i) => {
      return {
        text: `保单年度${item[0]}, 被保人${item[1]}岁时`,
        onClick: () => {
          selectedHandle(item, i);
        }
      };
    });
  }, [datas]);
  useEffect(() => {
    // 第一次进来把选中的利益演示表存入store
    dvaDispatch({
      productBenefit: productBenefit || {}
    }); // 这样存会和利益演示模块产生覆盖

    return subscribe(() => {
      setState({
        index: 0
      });
    }, 'benefitTable');
  }, []);
  if (!benefitTable) return null;
  const {
    sheetVisible,
    index
  } = store;
  const current = datas[index] || [];
  current[1] = Number(current[1]);
  const min = Number((_datas$ = datas[0]) === null || _datas$ === void 0 ? void 0 : _datas$[1]);
  const max = Number(datas[datas.length - 1][1]); // ;

  if (!datas || datas.length === 0 || !titles) return null;
  return /*#__PURE__*/React.createElement(StyledSlider, null, /*#__PURE__*/React.createElement(StyledMessage, null, /*#__PURE__*/React.createElement(StyledCondition, {
    onClick: () => {
      setState({
        sheetVisible: true
      });
    }
  }, /*#__PURE__*/React.createElement("div", null, "\u4FDD\u5355\u5E74\u5EA6", /*#__PURE__*/React.createElement("span", null, current[0]), "\u5E74, \u88AB\u4FDD\u4EBA", /*#__PURE__*/React.createElement("span", null, current[1]), "\u5C81\u65F6"), /*#__PURE__*/React.createElement(CaretDownOutlined, {
    style: {
      color: 'var(--theme-primary)'
    }
  })), titles.map((item, i) => {
    if (i < 2) {
      return null;
    }

    return /*#__PURE__*/React.createElement(StyledRow, {
      key: item
    }, /*#__PURE__*/React.createElement("div", null, item), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, current[i]), " ", !String(current[i]).endsWith('%') && '元'));
  })), /*#__PURE__*/React.createElement(StyledSliderWrap, null, /*#__PURE__*/React.createElement(StyledSliderAction, {
    onClick: () => {
      if (current[1] > min) {
        setState({
          index: index - 1
        });
      }
    }
  }, /*#__PURE__*/React.createElement(MinusOutlined, {
    style: {
      color: current[1] <= min ? '#ccc' : 'var(--theme-primary)',
      fontSize: '16px'
    }
  })), /*#__PURE__*/React.createElement(Slider, {
    getTooltipPopupContainer: triggerNode => triggerNode,
    min: min,
    max: max,
    defaultValue: current[1],
    tooltipVisible: true,
    tipFormatter: value => `${value}岁`,
    value: current[1],
    onChange: value => {
      const _index = datas.findIndex(item => {
        return item[1] == value;
      });

      setState({
        index: _index
      });
    }
  }), /*#__PURE__*/React.createElement(StyledSliderAction, {
    onClick: () => {
      if (current[1] < max) {
        setState({
          index: index + 1
        });
      }
    }
  }, /*#__PURE__*/React.createElement(PlusOutlined, {
    style: {
      color: current[1] >= max ? '#ccc' : 'var(--theme-primary)',
      fontSize: '16px'
    }
  }))), /*#__PURE__*/React.createElement(ActionSheet, {
    className: "rewrite-sheet-style",
    visible: sheetVisible,
    actions: dataList,
    onMaskClick: () => {
      setState({
        sheetVisible: false
      });
    }
  }));
};

export default BenefitDemonstrationSlider;
const StyledSlider = styled.div`
  margin: 0 14px;
`;
const StyledMessage = styled.div`
  margin: 14px 18px;
  border: 1px solid var(--theme-primary-shallow);
  /* padding: 14px 18px; */
  border-radius: 4px;
`;
const StyledSliderAction = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 22px;
  height: 22px;
  border: 1px solid #ccc;
  border-radius: 3px;
`;
const StyledSliderWrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .ant-slider {
    flex: 1;
    margin: 10px 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: rgba(0,0,0,.85);
    font-size: 14px;
    font-variant: tabular-nums;
    line-height: 1.5715;
    list-style: none;
    -webkit-font-feature-settings: "tnum";
    font-feature-settings: "tnum";
    position: relative;
    height: 12px;
    margin: 10px 20px;
    padding: 4px 0;
    cursor: pointer;
    -ms-touch-action: none;
    touch-action: none;
    .ant-slider-rail {
      height: 8px;
      border-radius: 4px;
      position: absolute;
      height: 4px;
      border-radius: 2px;
      -webkit-transition: background-color .3s;
      transition: background-color .3s;
      width: 100%;
      background-color: #f5f5f5;
    }
    .ant-slider-track {
      background-color: var(--theme-primary);
      height: 8px;
      border-radius: 4px;
      position: absolute;
    height: 4px;
    border-radius: 2px;
    -webkit-transition: background-color .3s;
    transition: background-color .3s;
     
    }
    .ant-slider-handle {
      border-color: var(--theme-primary-shallow);
      background-color: var(--theme-primary);
      width: 34px;
      height: 22px;
      border: none;
      border-radius: 11px;
      margin-top: -7px;

      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: -26px;
        left: 10px;
        width: 10px;
        height: 10px;
        border-left: 1px solid var(--theme-primary-shallow);
        border-bottom: 1px solid var(--theme-primary-shallow);
        background: #fff;
        transform: rotate(-45deg);
      }
    }
    .ant-tooltip-arrow {
      display: none;
    }
    .ant-tooltip {
      top: 0 !important;
    }
    .ant-tooltip-inner {
      padding: 0;
      line-height: 22px;
      background: none;
      min-height: unset;
      box-shadow: unset;
      color: #fff;
    }
  }
`;
const StyledCondition = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border-radius: 4px;
  background-color: var(--theme-primary-shallow);
  font-weight: 600;
  line-height: 1.1;
  margin-bottom: 6px;
  span {
    color: var(--theme-primary);
  }
`;
const StyledRow = styled.div`
  display: flex;
  div {
    line-height: 28px;
  }
  & > div:nth-child(1) {
    text-align: right;
    flex: 4;
  }
  & > div:nth-child(2) {
    text-align: left;
    flex: 5;
    padding-left: 16px;
  }
  span {
    color: var(--theme-primary);
    margin-right: 6px;
  }
`;